import { useSubscription } from "@apollo/client";
import { useQueryClient } from "@tanstack/react-query";
import { CREATIVE_DOWNLOAD_STATUS_UPDATED } from "../api/services/schedularService";

interface CreativeDownloadStatusUpdatedEvent {
  screenId: string;
  updatedAt: string;
  reason?: string | null;
}

export const useCreativeDownloadStatusSubscription = (
  screenId?: string,
  enabled: boolean = true,
) => {
  const queryClient = useQueryClient();

  useSubscription<{
    creativeDownloadStatusUpdated: CreativeDownloadStatusUpdatedEvent;
  }>(CREATIVE_DOWNLOAD_STATUS_UPDATED, {
    skip: !screenId || !enabled,
    variables: { screenId },
    onData: ({ data }) => {
      if (!data?.data?.creativeDownloadStatusUpdated || !screenId) {
        return;
      }

      queryClient.invalidateQueries({
        queryKey: ["screen-schedules", screenId],
      });
    },
    onError: (error) => {
      console.error(
        "[CreativeDownloadStatusSubscription] Error:",
        error.message,
      );
    },
  });
};
